<script module>
  import { resolve } from '$app/paths'
  import { helpPath } from '$lib/help/path'

  export const meta = {
    title: 'What is a session?',
    teaser:
      'Sessions are designed to help you fit movements into a tight schedule. They are\nshort and compressed into four to five minutes, allowing you to perform\nmeaningful exercise in a minimal amount of time. These sessions are suitable for\nsolo or group participation, giving you flexibility depending on your\npreference.',
    sort: 1,
  }
</script>

<h2>Starting a session</h2>
<p>You have two simple ways to start your short sessions:</p>
<ul>
  <li><strong>Start Immediately:</strong> Begin your workout right away.</li>
  <li>
    <strong>Start After a Timer:</strong> Delay your session start with a timer, allowing
    you to fit it into your day as you see fit.
  </li>
</ul>
<p>
  This approach helps you integrate movement into your routine, whether you're
  working around a fixed schedule or find unexpected free moments.
</p>
<h2>Guidance During Sessions</h2>
<p>Each session is accompanied by:</p>
<ul>
  <li>
    <strong>Animations:</strong> Visual demonstrations of each exercise to guide you
    through the movements accurately.
  </li>
  <li>
    <strong>Hints:</strong> Tips displayed during the session to remind you of form
    and technique.
  </li>
</ul>
<p>
  These features aim to assist you in performing exercises correctly, maximizing
  the benefits of your short session.
</p>
<h2>Customizing Your Workout</h2>
<p>
  Understanding that fitness levels and capabilities vary, the exercises in each
  session are chosen for their general accessibility. However, if you find
  certain movements unsuitable, you have the option to switch them out for
  alternatives.
  <a href={resolve(helpPath('product/alternative-movements'))}>Read more</a>.
</p>
